import { contentCardClicked } from '@/Analytics/Segment';

const cardClickAnalytics = (
  url: string,
  title: string,
  page: string,
  contentPosition: number,
  { railTitle, railStyle, railContains, railContentType },
  indexOnPage = 1,
) => {
  contentCardClicked({
    content_id: url,
    content_title: title,
    view_name: page,
    content_position: contentPosition,
    contains: railContains,
    style: railStyle,
    category_name: railTitle,
    content_type: railContentType,
    index_on_page: indexOnPage,
  });
};

export default cardClickAnalytics;
